import script from "./SpecialGoodsOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialGoodsOrder.vue?vue&type=script&setup=true&lang=js"

import "./SpecialGoodsOrder.vue?vue&type=style&index=0&id=44978078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44978078"]])

export default __exports__